import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { EventManager } from '@angular/platform-browser';
import { debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WindowResizeService {

  get onResize$(): Observable<Window> {
    return this.resizeSubject.asObservable()
      .pipe(debounceTime(500));
  }

  private resizeSubject: BehaviorSubject<Window>;

  constructor(private eventManager: EventManager) {
    this.resizeSubject = new BehaviorSubject(window);
    this.eventManager.addGlobalEventListener('window', 'resize', this.onResize.bind(this));
  }

  private onResize(event: UIEvent) {
    this.resizeSubject.next(<Window>event.target);
  }
}
